import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '../../services/http.service';
import { PackageService } from '../../services/package/package.service';

@Injectable()
export class ImageUploadService {
  url;

  constructor(
    private httpService: HttpService,
    private packageService: PackageService,
  ) {
    const data = this.packageService.get();

    if (!data) {
      return;
    }

    this.url = `api/v1/packages/${data.id}/recipients/${data.recipients[0].id}/signature/appearance`;
  }

  postFormData(image: File): Observable<any> {
    if (!this.url) {
      return Observable.throw('url is empty');
    }

    return this.httpService.postFormData(this.url, image);
  }
}
